export enum Snackbar {
	TYPE_DANGER = 'danger',
	TYPE_WARNING = 'warning',
	TYPE_SUCCESS = 'success',
	TYPE_INFO = 'info',
}
